import React from 'react';
import PropTypes from 'prop-types';
import { EmptyWrap, EmptyIllustration, EmptyCopy, EmptyAction, PrimaryButton } from './styled';
import Chevron from './chevron';
import storkImage from './assets/empty-unassigned-stork.png';
import bearImage from './assets/empty-my-books-bear.png';
import giftBoxImage from './assets/empty-gifts-giftbox.png';

// Illustrations exported from the Figma frames and committed alongside the code.
const EMPTY_STATES = {
  unassigned: {
    image: storkImage,
    alt: '',
    copy: "When you buy a yearbook, it'll show up here for you to set up.",
  },
  'my-books': {
    image: bearImage,
    alt: '',
    copy: 'Books you create yourself will appear here',
  },
  gifts: {
    image: giftBoxImage,
    alt: '',
    copy: 'Books you gift to someone so they can create the content will appear here',
  },
};

const EmptyState = ({ variant, onExplore }) => {
  const state = EMPTY_STATES[variant];
  if (!state) return null;

  return (
    <EmptyWrap>
      <EmptyIllustration src={state.image} alt={state.alt} />
      <EmptyCopy>{state.copy}</EmptyCopy>
      {/* <EmptyAction>
        <PrimaryButton type="button" onClick={onExplore}>
          Explore books
          <Chevron />
        </PrimaryButton>
      </EmptyAction> */}
    </EmptyWrap>
  );
};

EmptyState.propTypes = {
  variant: PropTypes.oneOf(['unassigned', 'my-books', 'gifts']).isRequired,
  onExplore: PropTypes.func.isRequired,
};

export default EmptyState;
